import { useFormikContext } from 'formik'

import ImmediateConsultationConfigForm, { PaymentReceiverStaff } from '../ImmediateConsultationConfigForm'
import { CreateMeetingLinkFormValues } from '../CreateMeetingLinkForm'
import { StaffData } from '../StaffSelectionTable'

type WizardOptionsStepProps = {
  staffs: StaffData[]
}

export default function WizardOptionsStep(props: WizardOptionsStepProps) {
  const { staffs } = props
  const { values } = useFormikContext<CreateMeetingLinkFormValues>()

  const selectedStaffs = staffs
    .filter((s) => values.staffs.includes(s.id))
    .map((s): PaymentReceiverStaff => ({
      _id: s.id,
      userInfo: { name: s.name, surname: s.surname },
      stripeActivated: s.stripeActivated,
      stripe: s.stripe,
    }))

  return <ImmediateConsultationConfigForm staffs={selectedStaffs} />
}
